import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import ImageCropper from "../crop_image/ImageCropper";
import Swal from "sweetalert2";

function JejakLangkahEdit() {
    const { id_jejak } = useParams();
    const navigate = useNavigate();

    const [formValue, setFormValue] = useState({
        foto: "",
        tanggal: "",
    });

    const [selectedFiles, setSelectedFiles] = useState({
        foto: null,
    });

    const [preview, setPreview] = useState({
        foto: null,
    });

    const [cropData, setCropData] = useState({
        isOpen: false,
        imageSrc: null,
        imageType: "",
    });

    const [croppedImage, setCroppedImage] = useState(null);

    const [groups, setGroups] = useState([]);

    // const fetchGroups = async () => {
    //   try {
    //     const response = await axios.get("http://localhost:3100/galeryGroup/readGaleriGroup");
    //     setGroups(response.data);
    //   } catch (error) {
    //     console.error("Error fetching groups:", error);
    //   }
    // };

    const fetchData = useCallback(async () => {
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            // Set token in axios headers
            axios.interceptors.request.use(
                (config) => {
                    config.headers.authorization = token;
                    return config;
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/jejak/readJejakById/${id_jejak}`
            );
            const data = response.data;
            setFormValue({
                foto: data.foto,
                tanggal: data.tanggal.split("T")[0],
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }, [id_jejak]);

    useEffect(() => {
        fetchData();
        // fetchGroups();
    }, [fetchData]);

    const openCropper = (file, imageType) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setCropData({
                isOpen: true,
                imageSrc: reader.result,
                imageType,
            });
        };
    };

    const closeCropper = () => {
        setCropData({
            isOpen: false,
            imageSrc: null,
            imageType: "",
        });
        setCroppedImage(null);
    };

    const applyCrop = () => {
        if (croppedImage instanceof Blob) {
            const blobUrl = URL.createObjectURL(croppedImage);
            setSelectedFiles({
                ...selectedFiles,
                [cropData.imageType]: croppedImage,
            });
            setPreview({
                ...preview,
                [cropData.imageType]: blobUrl,
            });
        } else {
            console.error("Cropped image is not a Blob:", croppedImage);
        }
        closeCropper();
    };

    const handleChange = (event) => {
        const { name, value, files } = event.target;
        if (files && files.length > 0) {
            const file = files[0];
            openCropper(file, name);
        } else {
            setFormValue({
                ...formValue,
                [name]: value,
            });
            if (name.startsWith("foto_")) {
                setPreview({
                    ...preview,
                    [name]: null,
                });
            }
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const FormDataInput = new FormData();
        if (selectedFiles.foto) {
            FormDataInput.append("foto", selectedFiles.foto);
        }
        FormDataInput.append("tanggal", formValue.tanggal);

        try {
            const response = await axios.put(
                `${process.env.REACT_APP_API_URL}/jejak/updateJejak/${id_jejak}`,
                FormDataInput,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            Swal.fire({
                title: "Success",
                text: "Data berhasil diperbarui",
                icon: "success",
            });
            navigate("/jejak");
        } catch (error) {
            console.error("Error updating data:", error);
            Swal.fire({
                title: "Error",
                text: "Data gagal diperbarui",
                icon: "error",
            });
        }
    };

    return (
        <div className="wrapper">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Administrasi</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item text-decoration-none">
                                        <Link className="text-decoration-none" to="/">
                                            Administrasi
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active">Jejak Langkah</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content galeri-edit">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Edit Jejak Langkah</h3>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            <div className="card-body">
                                                <div className="form-group galeri-edit-foto">
                                                    <label>Foto 1</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        name="foto"
                                                        accept="image/*"
                                                        placeholder="Masukkan foto 1"
                                                        onChange={handleChange}
                                                    />
                                                    {formValue.foto && (
                                                        <div className="preview-container-galery">
                                                            <img
                                                                src={preview.foto || formValue.foto}
                                                                alt="Preview"
                                                                className="preview-image-galery"
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                                <div>
                                                    <button type="submit" className="btn btn-info">
                                                        Simpan
                                                    </button>
                                                    <Link to="/jejak">
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary ml-2"
                                                        >
                                                            Batal
                                                        </button>
                                                    </Link>
                                                </div>
                                            </div>
                                        </form>
                                        {cropData.isOpen && (
                                            <ImageCropper
                                                imageSrc={cropData.imageSrc}
                                                setCroppedImage={setCroppedImage}
                                                onCropComplete={applyCrop}
                                                onClose={closeCropper}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default JejakLangkahEdit;
